export default __webpack_public_path__ + "static/media/page-not-found.a3002619.svg";